import PropTypes from "prop-types";
import "./Button.css";

const Button = ({
  title,
  className,
  onClick = null,
  backgroundColorVar = "--color-brig",
  titleColorVar = "--color-white",
  disabled = false,
  icon = null,
  width = "unset",
  minHeight = 34,
  margin = "0",
  ...meta
}) => {
  const Icon = icon;
  return (
    <button
      className={"button state-transition" + (!!className ? " " + className : "")}
      style={{
        color: `var(${titleColorVar})`,
        backgroundColor: `var(${backgroundColorVar})`,
        minHeight: `${minHeight}px`,
        paddingLeft: `${icon ? 10 : 22}px`,
        margin,
        width: width,
      }}
      onClick={onClick}
      disabled={disabled}
      {...meta}
    >
      {icon && <Icon />}
      {title}
    </button>
  );
};

Button.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  backgroundColorVar: PropTypes.string,
  titleColorVar: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.object,
  width: PropTypes.number,
  minHeight: PropTypes.number,
  margin: PropTypes.string,
};

export default Button;
